export default __webpack_public_path__ + "static/notary-section-image-d97682b72cda58b88a867b1e6085dc06.png";